import React from "react";
import { render } from "react-dom";
import { Toaster } from "react-hot-toast";

const TOASTER_CONTAINER_ID = "js-hot-toast-root";

const existingContainer = document.getElementById(TOASTER_CONTAINER_ID);
const toasterContainer = existingContainer || document.createElement("div");

if (!existingContainer) {
  toasterContainer.id = TOASTER_CONTAINER_ID;
  document.body.appendChild(toasterContainer);
}

render(
  <Toaster
    toastOptions={{
      duration: 2000,
      style: {
        fontSize: "1.2rem",
      },
      ariaProps: {
        role: "status",
        "aria-live": "polite",
      },
    }}
  />,
  toasterContainer
);
